import * as React from "react";
import { handleLineBreaks } from "../helpers/prismicHelpers";
import "./bigBullets.scss";
import { Link } from "gatsby";
export var BigBullets = function BigBullets(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "big-bullets"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed-width"
  }, /*#__PURE__*/React.createElement("h2", null, handleLineBreaks(data.primary.header)), data.fields.map(function (bullet) {
    return /*#__PURE__*/React.createElement("div", {
      className: "bullet"
    }, /*#__PURE__*/React.createElement("h2", null, handleLineBreaks(bullet.text)));
  }), /*#__PURE__*/React.createElement("div", {
    className: "btn-block"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "btn",
    to: data.primary.path
  }, data.primary.action))));
};